import { ReactElement, ElementType, useMemo, memo } from 'react';

import { OrdersFilterMenuGiverType } from '../types';
import { useOrdersFilterMenuGiverContext } from '../Context';

import OrdersFilterMenuGiverVariantInPreparation from './InPreparation';
import OrdersFilterMenuGiverVariantInTransit from './InTransit';
import OrdersFilterMenuGiverVariantFinalized from './Finalized';

const VARIANTS_COMPONENTS: Record<OrdersFilterMenuGiverType, ElementType> = {
  inPreparation: OrdersFilterMenuGiverVariantInPreparation,
  inTransit: OrdersFilterMenuGiverVariantInTransit,
  finalized: OrdersFilterMenuGiverVariantFinalized,
};

const OrdersFilterMenuGiverVariant = (): ReactElement => {
  const { type } = useOrdersFilterMenuGiverContext();

  const VariantComponent = useMemo(() => VARIANTS_COMPONENTS[type], [type]);

  return <VariantComponent />;
};

export default memo(OrdersFilterMenuGiverVariant);
